import React from 'react';

import Button from '$partials/ui/button';
import PropertyListingItem from '$partials/items/property-listing-item';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').PropertyCardGridBlock}
 */
const PropertyCardGridBlock = ({
    body,
    heading,
    properties,
    url
}) => {
    return (
        <div className='module-property-card-grid theme-light bg-main-background relative md:py-48 sm:py-40 py-24'>
            <div className='layout-container layout-site-outer-padding'>
                <div className='col-wrapper flex sm:flex-row flex-col gap-y-24'>
                    <div className='sm:w-4/12 col-padding flex flex-col gap-y-16'>
                        {heading &&
                            <h2 className='type-style-2 text-main-text-primary'>
                                {heading}
                            </h2>
                        }
                        {body &&
                            <div
                                className='type-style-body-r text-main-text-primary mt-4 rich-text'
                                dangerouslySetInnerHTML={{ __html: body }} />
                        }
                        {url &&
                            <Button
                                as='a'
                                className='button-secondary-filled button-secondary-filled--small type-style-eyebrow w-max'
                                href={url}>
                                View all
                            </Button>
                        }
                    </div>

                    <div className='sm:w-8/12 col-padding'>
                        <div className='sm:-mx-16 md:-mx-24'>
                            <div
                                aria-label='Properties'
                                className='grid grid-cols-1 md:grid-cols-2 gap-y-40'>
                                {properties?.edges?.map(
                                    /** @type {(edge: { node: import("$types/generated/cms-graphql.d.ts").SalePropertyListingItemFragment | import("$types/generated/cms-graphql.d.ts").RentalPropertyListingItemFragment }, i: number) => any} */
                                    (edge, i) => {
                                        const { node } = edge;

                                        return (
                                            <article
                                                className={`sm:px-16 md:px-24 md:border-l md:border-l-tint-dark ${i % 2 === 0 ? 'md:border-opacity-0' : 'md:border-opacity-20'}`}
                                                key={`${i}-${node.id}`}>
                                                <PropertyListingItem {...node} />
                                            </article>
                                        );
                                    }
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PropertyCardGridBlock;
